module.exports = __webpack_public_path__ + "media/images/draw_icon-f7d4e5a1.svg";